import { FormGroup, FormArray, FormControl } from '@angular/forms';
import { EModelQuality } from '@dataclouder/ngx-core';
import { ConversationEvents } from '../../models/agent.models';
import { ConversationType, TextEngines } from '../../models/conversation-enums';

// --- Form Group Structure Types ---

// Structure for IAIModel form group
export type ModelFormGroup = FormGroup<{
  id: FormControl<string>;
  modelName: FormControl<string>;
  provider: FormControl<string>;
  quality: FormControl<EModelQuality>;
}>;

export enum EDoActionType {
  ChangePrompt = 'changePrompt',
  ChangeGoal = 'changeGoal',
  ChangeModel = 'changeModel',
  Summarize = 'summarize',
}

export const DoActionTypeOptions = [
  { label: 'Cambiar Prompt', value: EDoActionType.ChangePrompt },
  { label: 'Cambiar Objetivo', value: EDoActionType.ChangeGoal },
  { label: 'Cambiar Modelo (Pendiente)', value: EDoActionType.ChangeModel },
  { label: 'Resumir (Pendiente)', value: EDoActionType.Summarize },
];

export enum SystemPromptType {
  SystemPrompt = 'systemPrompt',
  Language = 'language',
  ConversationType = 'conversationType',
  PictureDescription = 'pictureDescription',
  UserInformation = 'userInformation',
  CharacterDescription = 'characterDescription',
  ScenarioDescription = 'scenarioDescription',
  MessageExamples = 'messageExamples',
  JailBreak = 'jailBreak',
}

export interface ChangePromptAction {
  actionType: EDoActionType;
  systemPromptType: SystemPromptType;
  prompt: string;
}

// Structure for SimpleAgentTask form group
export type SimpleAgentTaskFormGroup = FormGroup<{
  systemPrompt: FormControl<string>;
  task: FormControl<string>;
  expectedResponseType: FormControl<string>;
  modelQuality: FormControl<EModelQuality>;
  model: ModelFormGroup;
}>;

export type DoActionFormGroup = FormGroup<{
  actionType: FormControl<string>;
  systemPromptType: FormControl<string>;
  prompt: FormControl<string>;
}>;

// Structure for DynamicCondition form group
export type DynamicConditionFormGroup = FormGroup<{
  what: FormControl<string>;
  when: FormControl<string>;
  value: FormControl<string>;
  then: FormControl<any[]>; // Corresponds to then: []
  // task: SimpleAgentTaskFormGroup;
  do: FormArray<DoActionFormGroup>; // Or FormArray<any> if tasks can be of different structures
}>;

// Structure for TriggerTasks form group
export type TriggerTasksFormGroup = FormGroup<{
  [ConversationEvents.OnUserMessage]: SimpleAgentTaskFormGroup;
  [ConversationEvents.OnAssistantMessage]: SimpleAgentTaskFormGroup;
  [ConversationEvents.OnGoalCompleted]: SimpleAgentTaskFormGroup;
}>;

// Structure for ConversationFlow form group
export type ConversationFlowFormGroup = FormGroup<{
  goal: SimpleAgentTaskFormGroup;
  triggerTasks: TriggerTasksFormGroup;
  bonus: FormControl<string>;
  dynamicConditions: FormArray<DynamicConditionFormGroup>;
}>;

// --- End Form Group Structure Types ---

// Structure for ConversationSettings form group
export type ConversationSettingsFormGroup = FormGroup<{
  textEngine: FormControl<TextEngines>;
  conversationType: FormControl<ConversationType>;
  autoStart: FormControl<boolean>;
  tts: FormGroup<{
    voice: FormControl<string>;
    secondaryVoice: FormControl<string>;
    speed: FormControl<string>;
    speedRate: FormControl<number>;
  }>;
}>;
